import { Box, useMediaQuery, useTheme } from '@mui/material';
import { type FC, type ReactNode, useEffect, useState } from 'react';

import { useNotificationPanel } from '@web/providers/NotificationPanelProvider/NotificationPanelProvider';

import { NotificationCenter } from '../NotificationCenter/NotificationCenter';
import AppDrawer from './AppDrawer';
import { AppNavbar } from './AppNavbar';
import { AppContent } from './styles';

interface AppNavigationProps {
  children: ReactNode;
}

export const AppNavigation: FC<AppNavigationProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(() => theme.breakpoints.down('lg'));

  const { isOpen: isNotificationPanelOpen } = useNotificationPanel();

  const [isOpenDrawer, setOpenDrawer] = useState<boolean>(!isMobile);

  const closeDrawer = (): void => setOpenDrawer(false);
  const openDrawer = (): void => setOpenDrawer(true);
  const toggleDrawer = (): void => setOpenDrawer((p) => !p);

  useEffect(() => {
    if (isMobile) closeDrawer();
  }, [isMobile]);

  return (
    <Box>
      <AppNavbar isOpen={isOpenDrawer} toggleDrawer={toggleDrawer} />
      <AppDrawer
        isMobile={isMobile}
        openDrawer={openDrawer}
        isOpen={isOpenDrawer}
        closeDrawer={closeDrawer}
      />

      <AppContent isOpen={isOpenDrawer} isNotificationPanelOpen={isNotificationPanelOpen}>
        {children}
      </AppContent>

      <NotificationCenter />
    </Box>
  );
};
